var map = {
	"./icon_admin absensi.svg": "4477",
	"./icon_admin master.svg": "2d10",
	"./icon_admin_information.svg": "715e",
	"./sidebar-icon-academic.svg": "f07a",
	"./sidebar-icon-dashboard.svg": "5fdc",
	"./sidebar-icon-master-data.svg": "9d70",
	"./sidebar-icon-recap.svg": "a905",
	"./sidebar-icon-settings.svg": "25b1",
	"./sidebar-icon-transaction.svg": "981a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d4ba";